/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";

import Modal, { ModalHeader } from "../../Modal";


import AdministrativeCertificateIssueList from "./AdministrativeCertificateIssueList";
import { ADMINISTRATIVE_CERTIFICATE_TYPES } from "../../../constants/TaxPortal/ADMINISTRATIVE_CERTIFICATE";
import AdministrativeCertificateIssue from "./AdministrativeCertificateIssue";
const administrativeCertificateList = ADMINISTRATIVE_CERTIFICATE_TYPES;

const AdministrativeCertificateIssuePopup = ({ close, isOpen }) => {
  const [selectedItem, setSelectedItem] = useState(null);

  const selectAdministrativeCertificateIssue = (id) => {
    const item = ADMINISTRATIVE_CERTIFICATE_TYPES.find(i => i.id === id);
    setSelectedItem(item);
  };

  const _close = () => {
    setTimeout(() => {
      setSelectedItem(null);
    }, 2000);
    close();
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        className='print-out'
        close={_close}
      >
        {selectedItem ?
          <div>
            <AdministrativeCertificateIssue
              selectedItem={selectedItem}
              close={_close}
            />
          </div> :
          <div>
            <ModalHeader>민원증명 발급신청</ModalHeader>
            <AdministrativeCertificateIssueList
              administrativeCertificateList={administrativeCertificateList}
              selectAdministrativeCertificateIssue={selectAdministrativeCertificateIssue}
            />
          </div>
        }
      </Modal>
    </>
  );
};

export default AdministrativeCertificateIssuePopup;
